import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable()
export class CustomOverlayContainer extends OverlayContainer {
  protected _createContainer(): void {
    const parent = document.querySelector('#app-main') || document.body;
    this._containerElement = document.createElement('div');
    this._containerElement.classList.add('cdk-overlay-container');
    parent.appendChild(this._containerElement);
  }
}
